import {
  ICustomerInfoConstantsInputsProperties,
  customerInfoConstants,
} from './constants';
import { IAddressFields } from '~/interfaces/address-fields';
interface IInputState {
  value: string;
  error: string;
  validation?: ICustomerInfoConstantsInputsProperties;
}

export interface IFormInitialState {
  [key: string]: IInputState;
}

const {
  firstName,
  lastName,
  emailAddress,
  phoneNumber,
  address,
  apartment,
  zipcode,
  city,
  state,
} = customerInfoConstants.inputs;

export const prepareBillingInitialFormState = (): IFormInitialState => {
  return {
    firstName: {
      value: '',
      error: '',
      validation: firstName,
    },
    lastName: {
      value: '',
      error: '',
      validation: lastName,
    },
    emailAddress: {
      value: '',
      error: '',
      validation: emailAddress,
    },
    phoneNumber: {
      value: '',
      error: '',
      validation: phoneNumber,
    },
    address: {
      value: '',
      error: '',
      validation: address,
    },
    apartment: {
      value: '',
      error: '',
      validation: apartment,
    },
    zipcode: {
      value: '',
      error: '',
      validation: zipcode,
    },
    city: {
      value: '',
      error: '',
      validation: city,
    },
    state: {
      value: '',
      error: '',
      validation: state,
    },
  };
};

export function lookupAddressFieldError(
  inputConstants: ICustomerInfoConstantsInputsProperties,
  inputValue: string = '',
) {
  if (inputConstants.required && !inputValue.length) {
    return inputConstants.requiredMsg;
  }
  if (inputConstants.regex && !inputValue.match(inputConstants.regex)) {
    return inputConstants.errorMsg;
  }
  return undefined;
}
export function prepareBillingFormStateWithShipping(
  shippingAddress: IAddressFields,
): IFormInitialState {
  return {
    firstName: {
      value: shippingAddress?.firstName || '',
      error: '',
      validation: customerInfoConstants.inputs.firstName,
    },
    lastName: {
      value: shippingAddress?.lastName || '',
      error: '',
      validation: customerInfoConstants.inputs.lastName,
    },
    emailAddress: {
      value: shippingAddress?.emailAddress || '',
      error: '',
      validation: customerInfoConstants.inputs.emailAddress,
    },
    phoneNumber: {
      value: shippingAddress?.phoneNumber || '',
      error: '',
      validation: customerInfoConstants.inputs.phoneNumber,
    },
    address: {
      value: shippingAddress?.address || '',
      error: '',
      validation: customerInfoConstants.inputs.address,
    },
    apartment: {
      value: shippingAddress?.apartment || '',
      error: '',
      validation: customerInfoConstants.inputs.apartment,
    },
    zipcode: {
      value: shippingAddress?.zipcode || '',
      error: '',
      validation: customerInfoConstants.inputs.zipcode,
    },
    city: {
      value: shippingAddress?.city || '',
      error: '',
      validation: customerInfoConstants.inputs.city,
    },
    state: {
      value: shippingAddress?.state || '',
      error: '',
      validation: customerInfoConstants.inputs.state,
    },
  };
}
